import { Injectable } from '@angular/core';
import { ScreenOrientation } from '@capacitor/screen-orientation';

@Injectable({ providedIn: 'root' })
export class ScreenOrientationService {
  constructor() {}

  async unlock() {
    try {
      await ScreenOrientation.unlock();
    } catch {
      console.error('[ERROR] Could not unlock orientation.');
    }
  }

  async lockPotrait() {
    try {
      await ScreenOrientation.lock({ orientation: 'portrait' });
    } catch {
      console.error('[ERROR] Could not lock orientation to "portrait" mode.');
    }
  }

  async lockLandscape() {
    try {
      await ScreenOrientation.lock({ orientation: 'landscape' });
    } catch {
      console.error('[ERROR] Could not lock orientation to "landscape" mode.');
    }
  }
}
